<template>
  <v-container full-height
               fluid
               class="pa-0">
    <v-row class="full-height"
           no-gutters>
      <v-col cols="12"
             class="full-height">
        <v-row class="full-height"
               no-gutters>
          <!-- inicio de sidebar -->
          <v-col cols="2"
                 class="smartbell-sidebar pa-0 full-height">
          </v-col>
          <!-- fin de sidebar -->
          <v-col cols="10"
                 style="position: relative"
                 class="full-height std-background-white-1">
            <!-- inicio de barra superior -->
            <v-row class="pl-6 pr-12 std-header-container mt-3 mb-4"
                   align="end"
                   justify="space-between"
                   no-gutters>
              <!-- inicio de botón de agregar vaca -->
              <v-col cols="3">
                <v-btn class="smartbell-greenButton button-text d-flex justify-space-around"
                block
                depressed
                elevation="6"
                height="40px"
                @click="openPage('CowForm')">
           <div class="d-flex justify-space-between align-center button-text btn-text-container">
             Agregar animal
             <i class="std-cow-white-icon" style="height: 26px;"></i>
           </div>
         </v-btn>
              </v-col>
              <!-- fin de botón de agregar vaca -->
              <!-- inicio de cambiar de rancho -->
              <v-col cols="3">
                <ChangeRanch></ChangeRanch>
              </v-col>
              <!-- fin de cambiar de rancho -->
              <!-- inicio de tarjeta de vacas en sistema -->
              <v-col cols="3">
                <SystemCardCount height="40px"
                                 width="100%"
                                 :number="cowCount"
                                 title-background="#57A7F5"
                                 number-background="#1460AA"
                                 @click="openPageDashCow('DashCow')"
                                 title="Vacas en Sistema">
                </SystemCardCount>
              </v-col>
              <!-- fin de tarjeta de vacas en sistema -->
            </v-row>
            <!-- fin de barra superior -->

            <!-- inicio de texto principal -->
            <v-row class="pl-6 pr-12 smart-title-1 home-title-container mb-4"
                   align="center"
                   no-gutters>
              <v-col cols="12" class="d-flex align-center justify-center">
                <div class="unselectable">Esta es la información esencial de tu rancho</div>
              </v-col>
              <!-- fin de tarjeta de vacas en sistema -->
            </v-row>
            <!-- fin de texto principal -->

            <!--inicio de contenedor central -->
            <v-row class="home-main-container"
                   v-if="view === 'main'"
                   align="center"
                   no-gutters>
              <!-- inicio de contenedor superior -->
              <v-col cols="12"
                     class="pa-0 main-cards-container">
                <v-row no-gutters
                       class="pa-0 full-height">
                  <v-col cols="5"
                         class="pb-6 pl-6 pr-3 full-height">
                    <!-- inicio de tarjeta de celos a confirmar -->
                    <v-card class="col-5 pa-0 full-height std-border-radius"
                            @click="view = 'heat'"
                            flat>
                      <HomeMediumCard :img="heatImage"
                                      fst-text="A revisar hoy"
                                      :fst-counter="onHeat"
                                      title="Celos a confirmar"
                                      :snd-counter="0"
                                      snd-text="Para seguimiento"
                                      color="#EB004E">
                      </HomeMediumCard>
                    </v-card>
                    <!-- fin de tarjeta de celos a confirmar -->
                  </v-col>
                  <!-- inicio de contenedor de tarjetas pequeñas  -->
                  <v-col cols="7"
                         class="pb-6 pl-3 pr-12 full-height">
                    <v-row no-gutters
                           justify="space-between"
                           class="full-height">
                      <!-- inicio de tarjeta de DIM -->
                      <v-card class="full-height"
                              style="width: 30%"
                              flat
                              @click="openPageDIM('DIM')">
                        <HomeSmallCard header="DIM"
                                       :counter="getFormatNumber(avgDim)"
                                       :img="dimImage">
                        </HomeSmallCard>
                      </v-card>
                      <!-- fin de tarjeta de DIM -->
                      <!-- inicio de tarjeta de enfermas -->
                      <v-card class="full-height"
                              flat
                              @click="view = 'health'"
                              style="width: 30%">
                        <HomeSmallCard header="Enfermas"
                                       counter="000"
                                       view="health"
                                       :img="sickImage">
                        </HomeSmallCard>
                      </v-card>
                      <!-- fin de tarjeta de enfermas -->
                      <!-- inicio de tarjeta de preñadas -->
                      <v-card class="full-height"
                              flat
                              @click="view = 'preg'"
                              style="width: 30%">
                        <HomeSmallCard header="Preñadas"
                                       view="preg"
                                       :counter="getFormatNumber(preg)"
                                       :img="pregImage">
                        </HomeSmallCard>
                      </v-card>
                      <!-- fin de tarjeta de preñadas -->
                    </v-row>
                  </v-col>
                  <!-- fin de contenedor de tarjetas pequeñas -->
                </v-row>
              </v-col>
              <!-- fin de contenedor superior -->

              <!-- inicio de contenedor inferior -->
              <v-col cols="12"
                     class="pa-0 main-cards-container">
                <v-row no-gutters
                       class="pa-0 full-height">
                  <v-col cols="5"
                         class="pb-6 pl-6 pr-3">
                    <!-- inicio de tarjeta de vacunas y tratamiento -->
                    <v-card class="col-5 pa-0"
                            @click="view = 'vacc'"
                            flat>
                      <HomeMediumCard :img="vaccImg"
                                      class="std-disabled"
                                      title="Vacas por vacunar y dar tratamiento"
                                      fst-text="Por vacunar"
                                      :fst-counter="onHeat"
                                      :snd-counter="0"
                                      snd-text="A dar tratamiento"
                                      color="#57a7f5">
                      </HomeMediumCard>
                    </v-card>
                    <!-- fin de tarjeta de vacunas y tratamiento -->
                  </v-col>
                  <!-- inicio de tarjeta distribución de hato -->
                  <v-col cols="7"
                         class="pb-6 pl-3 pr-12 full-height">
                    <v-card class="full-height"
                            flat
                            elevation="5">
                      <!-- inicio de header de tarjeta -->
                      <v-col cols="12"
                             class="d-flex align-center justify-center ltl-card-header">
                        <h4 style="font-size: 1.25rem; font-weight: bold;" class="std-text-white-1">Distribución del hato</h4>
                      </v-col>
                      <v-col cols="12" class="pa-0 md-card-sub-container">
                        <!-- inicio de contenido -->
                        <v-row no-gutters
                               align="center"
                               class="full-height">
                          <!-- inicio de chart -->
                          <v-col cols="4" class="full-height px-4 pt-4 pb-0">
                            <v-row no-gutters class="full-height justify-center" >
                              <v-col cols="12"
                                     style="max-width: 150px; position: relative;">
                                <visualization>
                                </visualization>
                              </v-col>
                              <v-col cols="12"
                                     class="card-text-2 d-flex align-center justify-center">
                                Ver más
                              </v-col>
                            </v-row>
                          </v-col>
                          <!-- fin de chart -->
                          <!-- inicio de tarjetas pequeñas -->
                          <v-col cols="8" class="full-height">
                            <v-row no-gutters
                                   class="full-height">
                              <!-- inicio de tarjeta de preñadas -->
                              <v-col cols="6"
                                     class="half-height">
                                <v-row no-gutters class="full-height pa-3">
                                  <v-col cols="8" class="d-flex justify-start align-center offset-4 md-card-no-container">
                                    <h1 class="card-number-4 pb-1 unselectable">002</h1>
                                  </v-col>
                                  <v-col cols="12" class="md-card-text-container">
                                    <v-row class="full-height" no-gutters>
                                      <v-col cols="4" class="d-flex justify-end">
                                        <v-icon left x-small color="#1460AA">mdi-checkbox-blank-circle</v-icon>
                                      </v-col>
                                      <v-col cols="8"
                                             class="d-flex align-center card-text-2 full-height">
                                        Preñadas
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <!-- fin de tarjeta de preñadas -->
                              <!-- inicio de tarjeta de con servicio -->
                              <v-col cols="6"
                                     class="half-height">
                                <v-row no-gutters class="full-height pa-3">
                                  <v-col cols="8"
                                         class="d-flex justify-start align-center offset-4 md-card-no-container">
                                    <h1 class="card-number-4 pb-1 unselectable">002</h1>
                                  </v-col>
                                  <v-col cols="12" class="md-card-text-container">
                                    <v-row class="full-height" no-gutters>
                                      <v-col cols="4" class="d-flex justify-end">
                                        <v-icon left x-small color="#1460AA">mdi-checkbox-blank-circle</v-icon>
                                      </v-col>
                                      <v-col cols="8"
                                             class="d-flex align-center card-text-2 full-height">
                                        Con servicio
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="6" class="half-height">
                                <v-row no-gutters class="full-height pa-3">
                                  <v-col cols="8"
                                         class="d-flex justify-start align-center offset-4 md-card-no-container">
                                    <h1 class="card-number-4 pb-1 unselectable">002</h1>
                                  </v-col>
                                  <v-col cols="12" class="md-card-text-container">
                                    <v-row class="full-height" no-gutters>
                                      <v-col cols="4" class="d-flex justify-end">
                                        <v-icon left x-small color="#1460AA">mdi-checkbox-blank-circle</v-icon>
                                      </v-col>
                                      <v-col cols="8"
                                             class="d-flex align-center card-text-2 full-height">
                                        Abiertas
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="6" class="half-height">
                                <v-row no-gutters class="full-height pa-3">
                                  <v-col cols="8"
                                         class="d-flex justify-start align-center offset-4 md-card-no-container">
                                    <h1 class="card-number-4 pb-1 unselectable">002</h1>
                                  </v-col>
                                  <v-col cols="12" class="md-card-text-container">
                                    <v-row class="full-height" no-gutters>
                                      <v-col cols="4" class="d-flex justify-end">
                                        <v-icon left x-small color="#1460AA">mdi-checkbox-blank-circle</v-icon>
                                      </v-col>
                                      <v-col cols="8"
                                             class="d-flex align-center card-text-2 full-height">
                                        Enfermas
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>
                          <!-- fin de tarjetas pequeñas -->
                        </v-row>
                      </v-col>

                      <!-- fin de header de tarjeta -->
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <!-- fin de contenedor inferior -->
            </v-row>
            <!-- fin de contenedor central -->

            <HomeFullCard header="Preñadas"
                          v-if="view === 'preg'"
                          single
                          style="height: 512px"
                          :img="pregImage"
                          view="preg"
                          table-second-column="Raza"
                          color="#1460aa">
            </HomeFullCard>
            <HomeFullCard header="Vacas por vacunar"
                          v-if="view === 'vacc'"
                          style="height: 512px"
                          :img="vaccImg"
                          table-second-column="Vacuna"
                          view="vacc"
                          color="#57A7F5">
            </HomeFullCard>
            <HomeFullCard header="Animales con celos a confirmar"
                          v-if="view === 'heat'"
                          style="height: 512px"
                          :img="heatImage"
                          table-second-column="Grupo"
                          view="heat"
                          color="#EB004E">
            </HomeFullCard>
            <HomeFullCard header="Enfermas"
                          :single="true"
                          v-if="view === 'health'"
                          style="height: 512px"
                          :img="heatImage"
                          table-second-column="Enfermedad"
                          view="health"
                          color="#1460AA">
            </HomeFullCard>
            <!-- inicio de footer-->
            <v-row class="home-footer-container"
                   style="position: absolute; bottom: 0; width: 100%"
                   no-gutters>
              <v-col cols="12"
                     class="full-height">
                <v-row no-gutters
                       class="full-height">
                  <v-col cols="12"
                         class="full-height footer-top-line">
                  </v-col>
                  <v-col cols="12"
                         class="pr-12 pl-6 footer-items-container">
                    <v-row no-gutters
                           align="center"
                           justify="space-around"
                           class="full-height footer-text">
                      <v-col cols="2"
                             class="d-flex align-center justify-center full-height">
                        <div class="unselectable">Preguntas frecuentes</div>
                      </v-col>
                      <v-col cols="2"
                             class="d-flex align-center justify-center full-height">
                        <div class="unselectable">Ayuda técnica</div>
                      </v-col>
                      <v-col cols="2"
                             class="d-flex align-center justify-center full-height">
                        <div class="unselectable">Planes y precios</div>
                      </v-col>
                      <v-col cols="2"
                             class="d-flex align-center justify-center full-height">
                      <div class="unselectable">Calcula tu eficiencia</div>
                      </v-col>
                      <v-col cols="2"
                             class="d-flex align-center justify-center full-height">
                      <div class="unselectable">Aviso de privacidad</div>
                      </v-col>
                      <v-col cols="2"
                             class="d-flex align-center justify-center full-height">
                      <div class="unselectable">Términos y condiciones</div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- fin de footer -->

          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ChangeRanch from '@/components/ChangeRanch.vue';
import Visualization from "../views/visualization";
import SystemCardCount from "../components/SystemCardCount";
import HomeSmallCard from "../components/HomeSmallCard";
import HomeFullCard from "../components/HomeFullCard";
import { EventBus } from './bus.js';
import HomeMediumCard from "../components/HomeMediumCard";
export default {
  name: 'Home',
    data () {
      return {
          series: [10, 2, 3, 2],
          //Chart.js options that controls the appearance of the chart
        specificList: false,
        specificListHeat: false,
        initialDash: true,
        openSpecificListName:'',
        activeSick: false,
        sickList: ['Mastitis', 'Brucelosis', 'Pulmonía', 'Cetosis', 'Tuberculosis', 'Cojera', 'Fiebre aftosa', 'Envenenamiento', 'Otro'],
        filterType: '',
        secondDateBirthFilter: '',
        firstDateBirthFilter: '',
        birthdayPicker: '',
        birthdayPickerTwo: '',
        dateHeatSelected:'',
          loading: false,
          view: 'main',
      }
  },
  components: {
      HomeMediumCard,
      HomeFullCard,
      HomeSmallCard,
      Visualization,
      ChangeRanch,
      SystemCardCount
  },
  computed: {
      userData(){
        return this.$store.getters.getUserData
      },
      animals() {
          return this.$store.getters.getAnimals;
      },
      numberOfAnimals() {
        if(this.$store.getters.getAnimals.length < 10){
            return "00"+this.$store.getters.getAnimals.length;
        } else if(this.$store.getters.getAnimals.length < 100){
            return "0"+this.$store.getters.getAnimals.length;
        } else if(this.$store.getters.getAnimals.length >= 100){
            return this.$store.getters.getAnimals.length;
        }
        return 0
      },
      /**
       * Obtiene el último rancho seleccionado desde la store
       * para posteriormente pasarlo como prop al componente
       * changeRanch
       * @returns {getters.getPaddockSelected}
       */
      paddockSelected() {
          return this.$store.getters.getPaddockSelected;
      },
      /**
       * Obtiene los ranchos actuales en el sistema desde la store
       * para posteriormente pasarlo como prop al componente
       * changeRanch
       * @returns {getters.getPaddockSelected}
       */
      currentPaddocks() {
        return this.$store.getters.getPaddocks;
      },
      onHeat() {
          return this.$store.getters.getCows.filter((cow) => {
              return cow.inHeat === "pending";
          }).length;
      },
      sickAnimals() {
          return this.$store.getters.getAnimals.filter((animal) => {
              return animal.isSick === true;
          }).length;
      },
      /**
       * Gets the averageDIM in the actual paddock
       */
      avgDim() {
          let avg = 0;
          let count = 0;
          if (this.$store.getters.getCows.length> 0) {
            this.$store.getters.getCows.forEach((cow) => {
              if (cow.dim !== 0) {
                  count++;
                  avg += cow.dim;
              }
             });
            avg = avg / count;
            return parseInt(avg.toPrecision(2));
          } else {
              return 0;
          }
      },

      preg() {
          return this.$store.getters.getCows.filter((animal) => {
              return animal.pregDate !== null;
          }).length;
      },
      dimImage() {
          return require('../assets/icons/icon_dim.png');
      },
      sickImage() {
          return require('../assets/icons/icon_sick.png');
      },
      pregImage() {
          return require('../assets/icons/icon_pregnant.png');
      },
      heatImage() {
          return require('../assets/icons/icon_heat.png');
      },
      vaccImg() {
          return require('../assets/icons/icon_vaccinate.png');
      },
      cowCount() {
      return this.$store.getters.getCowCount;
    },
  },
  watch: {
    openSpecificListName(){
        if (this.openSpecificListName === 'Enfermas') {
            this.filterType = "Filtro de enfermedad"
        } else if (this.openSpecificListName === 'Preñadas'){
            this.filterType = "Fecha parto estimada"
        }
    }
  },
  methods: {
      openSpecificList(section) {
            this.specificList = true
            this.openSpecificListName = section
            this.initialDash = false
      },
      getFormatNumber(number) {
          if (number < 10) {
              return '00' + number;
          } else if (number < 100) {
              return '0' + number;
          } else {
              return number;
          }
      },
      closeSpecificList(){
            this.specificList = false
            this.openSpecificListName = ''
            this.secondDateBirthFilter = ''
            this.firstDateBirthFilter = ''
            this.birthdayPicker = ''
            this.birthdayPickerTwo = ''
            setTimeout(()=>{
              this.initialDash = true
            }, 1000);

      },
         openSpecificListHeat(section) {
            this.specificListHeat = true
            this.openSpecificListName = section
            this.initialDash = false
      },
      closeSpecificListHeat(){
            this.specificListHeat = false
            this.openSpecificListName = ''
            setTimeout(()=>{
              this.initialDash = true
            }, 1000);

      },
      openPage(page){
          this.$router.push({ name: page })
      },
      openPageDIM() {
      this.$router.push({name: 'DashResume'})
    },
    openPageDashCow() {
      this.$router.push({name: 'DashCow'})
    },
  },
  mounted () {
        this.$store.commit('renderNav',true);
        EventBus.$on('close-full', () => {
            this.view = 'main';
        });
        /*if (this.$store.getters.getUserData.onboarding === false){
            this.$router.push({name:'Onboarding'});
        }
        this.renderChart(this.datacollection, this.options)*/
  }
};
</script>

<style lang="css">
  @import '../style/Home.css';
</style>
